import React from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineLogout } from "@react-icons/all-files/hi/HiOutlineLogout";
import { HiOutlineShieldExclamation } from "@react-icons/all-files/hi/HiOutlineShieldExclamation";
import { useAdminAuth } from "../../contexts/AdminAuthContext";

interface TopbarProps {
  envLabel: string;
}

const Topbar: React.FC<TopbarProps> = ({ envLabel }) => {
  const navigate = useNavigate();
  const { user, logout } = useAdminAuth();

  return (
    <header className="flex h-14 items-center justify-between border-b border-surface-border bg-surface-base px-6 backdrop-blur">
      <div className="flex items-center gap-3">
        <span className="rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary">
          {envLabel}
        </span>
        <p className="text-sm text-muted">Passport admin guard / scope:admin</p>
      </div>

      <div className="flex items-center gap-3 text-sm">
        <button
          onClick={() => navigate("/audit-logs")}
          className="flex items-center gap-2 rounded-lg border border-surface-border px-3 py-1.5 text-ink opacity-80 transition hover:border-primary/40 hover:text-primary"
        >
          <HiOutlineShieldExclamation className="h-4 w-4" />
          <span>操作ログ</span>
        </button>

        <div className="h-8 w-px bg-surface-border" />

        <div className="text-right">
          <p className="text-xs text-muted">{user?.role || "role"}</p>
          <p className="text-sm font-semibold text-ink">{user?.name || "admin"}</p>
        </div>
        <button
          onClick={logout}
          className="rounded-lg bg-ink px-3 py-1.5 text-xs font-semibold text-white opacity-90 transition hover:opacity-100"
        >
          <HiOutlineLogout className="inline h-4 w-4" />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
